l = require 'lib/localize'
React = require 'react'
SettingSectionComponent = require 'views/organization/setting-section-component'
SlackTeamComponent = require 'views/organization/slack-team-component'
t = require('views/internal/recup-with-helpers')('org_account')

SLACK_ADD_URL = "https://slack.com/oauth/authorize"

class SlackComponent extends React.Component
  @displayName: "SlackComponent"

  render: t.renderable ->
    { isAdmin, hasBC, slackAssociation, deleteSlackAssociation, changeSlackSelfJoin } = @props

    t.div =>
      if !slackAssociation
        t.createElement SettingSectionComponent,
          header: t.render ->
            t.format 'slack-team-linking'
          contents: t.render ->
            t.format 'loading'
          changeContent: t.render -> t.a href: SLACK_ADD_URL, disabled: true, class: '.button-link.u-text-align-center.disabled', -> t.text ""
          changeClasses: t.classify({ 'u.text-align-center' })

        return

      { associated, canChange, adminOnly, teams, qs } = slackAssociation

      contents = t.render ->
        t.div ->
          t.p ->
            t.format 'link-your-trello-and-slack-teams-together'
            t.text ' '
            t.a '.quiet', { href: "http://help.trello.com/article/1049-slack-app", target: 'slack_help' }, ->
              t.format 'learn-more'
          if !canChange
            t.p '.helper.u-float-left', ->
              t.format 'you-need-to-be-an-admin-to-link-this-trello-team-to-a-slack-team'

      slackUrl = if canChange then SLACK_ADD_URL + qs else '#'

      buttonClasses = {
        'slack-button',
        disabled: !canChange
      }

      t.createElement SettingSectionComponent,
        header: t.render ->
          t.format 'slack-team-linking'
        contents: contents
        changeContent: t.render -> t.a href: slackUrl, disabled: !canChange, ->
          t.img
            class: t.classify(buttonClasses)
            alt: t.l('add-to-slack'),
            src: "https://platform.slack-edge.com/img/add_to_slack.png",
            srcSet: "https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
        changeClasses: t.classify({ 'u.text-align-center' })

      if associated
        teams.forEach (team) ->
          t.createElement SlackTeamComponent,
            icon: t.render ->
              t.img
                class: 'slack-team-icon'
                alt: 'Slack Team Icon'
                src: team.icon
            header: t.render ->
              t.div ->
                t.text team.name
            contents: t.render ->
              t.div ->
                t.div ->
                  t.p ->
                    t.format 'this-team-is-linked-to-domain', { domain: team.domain }
                  t.p class: t.classify(quiet: !hasBC || !isAdmin), ->
                    if team.selfJoin
                      t.format 'slack-members-self-join'
                    else
                      t.format 'slack-members-invite-only'
                    t.icon 'business-class', class: 'icon-business-class-color'
                if !canChange
                  t.p '.helper.u-float-left', ->
                    t.format 'you-need-to-be-an-admin-to-change-this-setting'
            canChange: canChange
            isAdmin: isAdmin
            hasBC: hasBC
            team: team
            changeSlackSelfJoin: changeSlackSelfJoin
            deleteSlackAssociation: deleteSlackAssociation

      return

module.exports = SlackComponent



// WEBPACK FOOTER //
// ./app/scripts/views/organization/slack-component.coffee